import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../common/Pagination";
import GenericAccountTable from "./GenericAccountTable";
import { fetchClientsAccounts } from "../../redux/slice/clientAccount";
import Loader from "../../common/Loader";

const ClientsAccount = ({ clientId }) => {
  const dispatch = useDispatch();
  const [isReady, setIsReady] = useState(false);
  const userData = JSON.parse(localStorage.getItem("user"));
  const loggedInId = userData?.data?.user?.id;
  const userType = userData?.data?.user?.userType;

  const finalClientId = userType === "client" ? loggedInId : clientId;

  const [page, setPage] = useState({
    currentPage: 1,
    itemsPerPage: 10,
  });

  const [searchText, setSearchText] = useState("");

  const { accountsList, accountPagination, loading } = useSelector(
    (state) => state.fetchClientsAccountsResponse
  );

  const columns = [
    { header: "Account Name", key: "accountName" },
    { header: "Other Investors", key: "investors" },
    { header: "Financial Advisor", key: "financialAdvisor" },
    { header: "Investments", key: "investments" },
    { header: "Total Invested", key: "totalInvested" },
  ];

  useEffect(() => { 
    if (!isReady) return;
    const handler = setTimeout(() => {
      setPage((prev) => ({ ...prev, currentPage: 1 }));

      dispatch(
        fetchClientsAccounts({
          clientId: finalClientId,   
          search: searchText,
          page: 1,
          limit: page.itemsPerPage,
        })
      );
    }, 1000);

    return () => clearTimeout(handler);
  }, [searchText]);

  useEffect(() => {
    dispatch(
      fetchClientsAccounts({
        clientId: finalClientId,
        search: searchText,
        page: page.currentPage,
        limit: page.itemsPerPage,
      })
    );
    setIsReady(true);
  }, [page.currentPage, page.itemsPerPage, finalClientId]);

  const formattedData =
    accountsList?.map((item) => ({
      accountName: item.ownerEntityName,
      investors: item.users?.map((u) => u.userName) || [],
      investments: item.properties?.length || 0,
      financialAdvisor: item.advisors?.map((a) => a.userName) || ["Qss Advisor"],
      totalInvested: item.totalValue || "$0",
    })) || [];

  return (
    <>
      {loading && <Loader />}

      <div className="page__body">
        <div className="tableWrap">
          <div className="tableWrap__head">
            <div className="formRow m_0 w_100 formRow--flexEnd">
              <div className="formCol formCol--flex">
                <div className="formCol flexField">
                  <input
                    className="form__input form__input--search"
                    type="text"
                    placeholder="Account Name or Other Investors names"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <GenericAccountTable
            columns={columns}
            data={formattedData}
            loading={loading}
          />
        </div>
      </div>

      {accountPagination?.totalItems > 0 && userType==="client" && (
        <Pagination
          page={page}
          setPage={setPage}
          flag="client-account"
        />
      )}
    </>
  );
};

export default ClientsAccount;
